export const environment = {
  production: false,
  appName: '[DEV] GarageFolio',
  apiBaseUrl: 'https://apidev.mygaragefolio.com/api/v1',
  memberId: '9ad2fb7c-2333-4309-9050-f33cf9db1e4d',
  inspection3d: {
    defaultModelUrl: '/assets/3d/coupe.glb',
    byCategory: {
      coupe: '/assets/3d/coupe.glb',
      sedan: '/assets/3d/sedan.glb',
      suv: '/assets/3d/suv.glb',
      long_roof: '/assets/3d/long_roof.glb',
    },
  },
};
